<template>
  <div class="ls-container">
    <div class="ls-item pos">
      <div class="chart" ref="myChart"></div>
      <!-- 显示百分比 -->
      <div class="text">
        <span ref="text">
          {{ Math.floor((item.number / item.total) * 100).toFixed(0) }}
        </span>
        %
      </div>
      <!-- 黄线边框 -->
      <img
        class="border-1"
        ref="border1"
        src="../../../assets/dispatch/border1.png"
        alt=""
      />
      <!-- 绿线边框 -->
      <img
        class="border-2"
        ref="border2"
        src="../../../assets/dispatch/border2.png"
        alt=""
      />
    </div>
    <div class="ls-item">
      <div class="title">
        <div class="icon">
          <img
            :src="require('../../../assets/dispatch/' + item.icon + '.png')"
            alt=""
          />
        </div>
        <div class="name">{{ item.name }}</div>
      </div>
      <div class="number" :style="{ color: item.color }" ref="number1">
        {{ item.total }}
      </div>
      <div class="showview">
        <div>
          <div class="showview-item">
            <div class="left">
              <div class="porint"></div>
              <div>正常</div>
            </div>
            <div class="right" ref="number2">{{ item.number }}</div>
          </div>
          <div class="showview-item">
            <div class="left">
              <div class="porint yellow"></div>
              <div>异常</div>
            </div>
            <div class="right" ref="number3">
              {{ item.total - item.number }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    props: {
      item: {
        type: Object,
        default() {
          return {}
        },
      },
    },
    data() {
      return {}
    },
    mounted() {
      this.$nextTick(() => {
        setTimeout(() => {
          this.init()
        }, 1500)
      })
    },
    beforeDestroy() {
      this.$animejs.remove([
        this.$refs.border1,
        this.$refs.border2,
        this.$refs.text,
        this.$refs.number1,
        this.$refs.number2,
        this.$refs.number3,
      ])
    },
    methods: {
      init() {
        let chartDom = this.$refs.myChart
        let myChart = this.$echarts.init(chartDom)
        let option
        let trafficWay = [
          {
            value: this.item.number,
          },
          {
            value: this.item.total - this.item.number,
          },
        ]

        let data = []
        let color = ['#02FFA3', '#FFDE00']
        for (let i = 0; i < trafficWay.length; i++) {
          data.push(
            {
              value: trafficWay[i].value,
              itemStyle: {
                normal: {
                  borderWidth: 6,
                  shadowBlur: 10,

                  borderRadius: 10,
                  borderColor: color[i],
                  shadowColor: color[i],
                },
              },
            },
            {
              value: Math.ceil(this.item.total * 0.02),
              name: '',
              itemStyle: {
                normal: {
                  label: {
                    show: false,
                  },
                  labelLine: {
                    show: false,
                  },
                  color: 'rgba(0, 0, 0, 0)',
                  borderColor: 'rgba(0, 0, 0, 0)',
                  borderWidth: 0,
                },
              },
            }
          )
        }
        let seriesOption = [
          {
            name: '',
            type: 'pie',
            clockWise: false,
            radius: [50, 50],
            width: 50,
            height: 50,
            hoverAnimation: false,
            center: ['50%', '55%'],
            left: 'center',
            top: 'center',
            itemStyle: {
              normal: {
                label: {
                  show: false,
                },
              },
            },
            data: data,
          },
        ]
        option = {
          color: color,
          graphic: {
            elements: [
              {
                type: 'image',
                z: 3,
                style: {
                  // image: img,
                  width: 50,
                  height: 50,
                },
                left: '20%',
                top: 'center',
              },
            ],
          },
          tooltip: {
            show: false,
          },
          toolbox: {
            show: false,
          },
          series: seriesOption,
        }
        myChart.setOption(option)
        // 圆环转动
        this.$animejs({
          targets: this.$refs.border1,
          easing: 'easeInQuad',
          scale: [1.5, 1],
          rotate: [360, 0],
          duration: 1000,
        })
        this.$animejs({
          targets: this.$refs.border2,
          easing: 'easeInQuad',
          scale: [1.5, 1],
          rotate: [-360, 0],
          duration: 1000,
        })
        setTimeout(() => {
          this.$animejs.remove([this.$refs.border1, this.$refs.border2])
          this.$animejs({
            targets: this.$refs.border1,
            easing: 'linear',
            loop: true,
            rotate: 360,
            duration: 10000,
          })
          this.$animejs({
            targets: this.$refs.border2,
            easing: 'linear',
            loop: true,
            rotate: -360,
            duration: 10000,
          })
        }, 1000)
        // 数字滚动动画
        this.$animejs({
          targets: this.$refs.text,
          innerHTML: [
            0,
            Math.floor((this.item.number / this.item.total) * 100).toFixed(0),
          ],
          cycles: 130,
          round: 1,
          easing: 'linear',
        })
        this.$animejs({
          targets: this.$refs.number1,
          innerHTML: [0, this.item.total],
          cycles: 130,
          round: 1,
          easing: 'linear',
        })
        this.$animejs({
          targets: this.$refs.number2,
          innerHTML: [0, this.item.number],
          cycles: 130,
          round: 1,
          easing: 'linear',
        })
        this.$animejs({
          targets: this.$refs.number3,
          innerHTML: [0, this.item.total - this.item.number],
          cycles: 130,
          round: 1,
          easing: 'linear',
        })
      },
    },
  }
</script>
<style lang="scss" scoped>
  .ls-container {
    display: flex;
    flex-direction: row;
    height: 100%;
    .ls-item {
      width: 50%;
      position: relative;
      overflow: hidden;
      .chart {
        width: 6.5vw;
        height: 6.5vw;
      }
      .title {
        display: flex;
        padding-left: 1.0416vw;
        margin-top: 1.0416vw;
        align-items: center;
        .icon {
          width: 2.5vw;
          img {
            width: 100%;
          }
        }
        .name {
          font-size: 16px;
          color: white;
          margin-left: -1.0416vw;
        }
      }
      .number {
        font-size: 1.1458vw;
        padding-left: 2.3958vw;
      }
      .showview {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        .showview-item {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          margin-top: 1.0416vw;
          .left {
            display: flex;
            flex-direction: row;
            align-items: center;
            font-size: 14px;
            color: #e6e6e6;
            margin-right: 1.0416vw;
            .porint {
              width: 8px;
              height: 8px;
              border-radius: 50%;
              background-color: #02ffa3;
              margin-right: 0.78125vw;
            }
            .porint.yellow {
              background-color: #ffde00;
            }
          }
          .right {
            font-size: 1.14583vw;
            color: #ffffff;
          }
        }
      }
    }
    .ls-item.pos {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      .text {
        position: absolute;
        z-index: 9;
        font-size: 1.1458vw;
        color: white;
      }
      .border-1 {
        position: absolute;
        z-index: 8;
        width: 7.1875vw;
      }
      .border-2 {
        position: absolute;
        z-index: 8;
        width: 8.25vw;
      }
    }
  }
</style>
